module.exports = __webpack_public_path__ + "static/media/barbara4.cebc6d6c.mp3";